import OrderRow from './OrderRow';
import { withI18n } from 'react-i18next';

export default withI18n()(OrderRow);
